import { Color } from '@dreryk/color-common-api';

import { createTranslatedText } from '@dreryk/react-common';
import {
   IconFillColor,
   IconWrapper,
   InteractiveTable,
   QuestionmarkCircleIcon,
   Text,
   Tooltip,
} from '@dreryk/react-components';

import { StyledHexColorBar } from '../ReceptionServiceInteractiveTable.styled';

type ReceptionServiceInteractiveTableServiceCellProps = {
   readonly color: Color | undefined;
   readonly name: string;
   readonly additionalInformation: string | undefined;
};

export const ReceptionServiceInteractiveTableServiceCell = (
   props: ReceptionServiceInteractiveTableServiceCellProps
): JSX.Element => {
   return (
      <InteractiveTable.Cell testId={'service'}>
         {props.color ? <StyledHexColorBar testId={'color'} color={props.color.asHexString()} /> : null}
         <Text testId={'name'}>{props.name}</Text>
         {props.additionalInformation ? (
            <Tooltip testId={'additionalInformation'} content={createTranslatedText(props.additionalInformation)}>
               <IconWrapper testId={'usingDefaultConfiguration'} fillColor={IconFillColor.PRIMARY}>
                  <QuestionmarkCircleIcon />
               </IconWrapper>
            </Tooltip>
         ) : null}
      </InteractiveTable.Cell>
   );
};
